import IpubTree from './src/main'

/* istanbul ignore next */
IpubTree.install = function(Vue) {
  Vue.component(IpubTree.name, IpubTree)
}

export default IpubTree
